/**
 * Export a .csv file, client-side (no backend round-trip).
 *
 * Emits a UTF-8 BOM so Excel pt-BR opens accents correctly, and uses ";" as
 * the default separator (Excel pt-BR convention — same as the import template).
 *
 * @param {Object[]} rows - Array of plain objects; keys become column headers.
 * @param {string} filename - File name without extension.
 * @param {string} [separator=";"] - Column separator.
 */
export const exportToCsv = (rows, filename, separator = ";") => {
  if (!rows.length) return;

  const escapeCell = value => {
    const cell = String(value ?? "");
    if (
      cell.includes(separator) ||
      cell.includes('"') ||
      cell.includes("\n") ||
      cell.includes("\r")
    ) {
      return `"${cell.replace(/"/g, '""')}"`;
    }
    return cell;
  };

  const headers = Object.keys(rows[0]);
  const lines = [
    headers.map(escapeCell).join(separator),
    ...rows.map(row => headers.map(h => escapeCell(row[h])).join(separator))
  ];

  const blob = new Blob(["\ufeff" + lines.join("\r\n")], {
    type: "text/csv;charset=utf-8;"
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
